import React, { useState, useEffect, useRef } from "react";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";

const ValueColorWrapper = ({ children }) => {
  // We initialize color to inherit
  const [color, setColor] = useState("inherit");
  // We use this  custom hook to get the previous value of children
  const prevValue = usePrevious(children);

  children = parseInt(children, 10);

  // This will compare values and update state accordingly
  useEffect(() => {
    if (children > prevValue) {
      setColor(green[800]);
    } else if (children < prevValue) {
      setColor(red[800]);
    }
  }, [children]);

  if (isNaN(children) || children === null) {
    return <span style={{ color: "inherit" }}>--</span>;
  }
  return <span style={{ color }}>{children}</span>;
};

// Custom hook to store previous value
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

export default ValueColorWrapper;

////////////////////////////////////////////////////////////////////////

// export default class ValueColorWrapper extends Component {
//   state = {
//     color: "inherit"
//   };

//   componentDidUpdate = prevProps => {
//     if (this.props.children !== prevProps.children) {
//       if (this.props.children > prevProps.children) {
//         this.setState({ color: green[800] });
//       } else if (this.props.children < prevProps.children) {
//         this.setState({ color: red[800] });
//       }
//     }
//   };
//   render = () => {
//     let { children } = this.props;
//     children = parseInt(children, 10);
//     const { color } = this.state;

//     if (isNaN(children) || children === null) {
//       return React.createElement("span", { style: { color: "inherit" } }, "--");
//     }
//     return React.createElement("span", {
//       style: {
//         color
//       },
//       children
//     });
//   };
// }

//////////////////////////////////////////
// import React, { Component } from "react";

// export default class TextColorWrapper extends Component {
//   state = {
//     color: "inherit",
//     unit: ""
//   };

//   componentDidUpdate = prevProps => {
//     if (this.props.value !== prevProps.value) {
//       if (this.props.value > prevProps.value) {
//         this.setState({ color: "green" });
//       } else if (this.props.value < prevProps.value) {
//         this.setState({ color: "red" });
//       }
//     }
//   };
//   render() {
//     const { value, unit } = this.props;

//     if (isNaN(value) || value === null) {
//       return <span> -- </span>;
//     }
//     return (
//       <span style={{ color: this.state.color }}>
//         {value} {unit}
//       </span>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/components/common/ValueColorWrapper.js